import * as React from 'react';
import dayjs, { Dayjs } from 'dayjs';
import 'dayjs/locale/fr';
import 'dayjs/locale/nl-be';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { FC, useState } from 'react';
import { UseTranslationContext } from '../Context/TranslationContext';
import { createTheme, TextField, ThemeProvider } from '@mui/material';

const locales = ['en', 'fr', 'nl-be'] as const;
 
interface IdatepickerProps {
  startDate: Dayjs;
  updateDate(selectedDate: Dayjs): void;

}

const LocalizedDatePicker: FC<IdatepickerProps> = (props: any) => {

  const {currentLanguage} = UseTranslationContext();

  const [locale, setLocale] = useState<typeof locales[number]>('nl-be');
  const [datePickerValue, setDatePickerValue] = useState<Dayjs | null>(props.startDate);

  React.useEffect(() => {
    setDatePickerValue(props.startDate);
    props.updateDate(props.startDate);
  },[props.startDate])

  React.useEffect(() => {
    if(currentLanguage != locale)
    {
      if(currentLanguage == 'fr')
      {
        setLocale('fr');
      }
      else if(currentLanguage == 'nl')
      {
        setLocale('nl-be');
      }
      else
      {
        setLocale('en');
      }
    }
  },[currentLanguage])

  const UpdateDateValue = (d: Dayjs | null) => {
    setDatePickerValue(d);
    props.updateDate(d);
  }

  const theme = createTheme({
    typography: {
      fontSize: 16,
      htmlFontSize: 16
    },
    components: {
      MuiIconButton: {
        styleOverrides: {
          root: {
            color : '#90bbb5'
          }
        }
      }
    },
  });
  

  return (
    <>
    <ThemeProvider theme={theme}>

      <LocalizationProvider
        dateAdapter={AdapterDayjs}
        adapterLocale={locale}
      >
        <DatePicker
          value={datePickerValue}
          onChange={(newValue) => UpdateDateValue(newValue)}
          renderInput={(params) => <TextField {...params} 
            sx={
              {
                padding: "0px",
                "& .MuiInputBase-root": {
                  height: 38,
                  fontSize: '0.875rem'
                },
                "& .MuiOutlinedInput-root.Mui-focused": {
                  "& > fieldset": {
                    border:"2px solid #354c59"
                  }
                }
              }
            }
          />        
        }
        />
      </LocalizationProvider>
      </ThemeProvider>
    </>
  );
}

export default LocalizedDatePicker;

